import { gql, useQuery } from '@apollo/client';

const QUERY = gql`
  query versionsWithSpecialties {
    versionsWithSpecialties {
      version
      specialties
    }
  }
`;

export const useVersionsWithSpecialties = () => {
  return useQuery<{
    versionsWithSpecialties: [{ version: number; specialties: [string] }];
  }>(QUERY);
};
